import { IUserDTO } from 'business/models/Models';
import useModel from 'business/models/useModel';
import UserGroupService from 'business/services/UserGroupService';
import { useNavigate } from 'react-router-dom';
import React, { useCallback, ChangeEvent, useState } from 'react';
import { getUserId, showAlertSnackBar } from 'utils/Global';
import ChangePasswordForm from '../forms/user/changePassword';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';

interface Props {
  closeModal: () => void;
}

const ChangePassword = (props: Props) => {
  const { closeModal } = props;
  const navigate = useNavigate();
  const [updatePasswordAction] = useModel(UserGroupService, 'updatePassword');
  const [passwordDetail, setPasswordDetail] = useState({
    password: '',
    confirmPassword: '',
  });

  const handleSetPasswordDetail = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setPasswordDetail((prv) => ({
        ...prv,
        [e.target.name]: isNaN(parseInt(e.target.value))
          ? e.target.value
          : parseInt(e.target.value),
      }));
    },
    [setPasswordDetail],
  );

  const handleOnSave = useCallback(async () => {
    const user: IUserDTO = {
      id: await getUserId(),
      password: passwordDetail.password,
      isPersistentSession: false,
    };
    await updatePasswordAction(user);
    closeModal();
    showAlertSnackBar(
      EAlertType.SUCCESS,
      ESnackBarPosition.TOP,
      'Password changed successfully.',
    );
    // wait for modal to close otherwise browser will retain current view of modal until login page loads
    setTimeout(() => navigate('/logout', { replace: true }), 300);
  }, [passwordDetail]);

  return (
    <ChangePasswordForm
      handleSave={handleOnSave}
      handleSetPasswordDetail={handleSetPasswordDetail}
      passwordDetail={passwordDetail}
    />
  );
};

export default ChangePassword;
